import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { IfBenefactorDirective } from './directives/if-benefactor.directive'
import { IfDependentDirective } from './directives/if-dependent.directive'
import { Account } from './models'
import { featureKey, reducer } from './ngrx'
import { AccountEffects } from './ngrx/effects'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(featureKey, reducer),
    EffectsModule.forFeature([AccountEffects]),
    IfBenefactorDirective,
    IfDependentDirective,
  ],
  exports: [IfBenefactorDirective, IfDependentDirective],
  providers: [{ provide: Account, useValue: new Account() }],
})
export class AccountModule {}
